export var config = {

    "default": {

          "test": {
            "skip": true,
            "streamurl": {
              "lq": "http://skip-1hz.streamabc.net/890rtl-mostwanted-mp3-128-41",
              "hq": "http://localhost:9000/radiohh-earlybird-mp3-128"
            },
            "name": "Skip-Test External",
            "image": "	https://s3.eu-central-1.amazonaws.com/streamabc-player/890rtl/channels/1_600x600_89.0RTLMostWanted_bg-colored_colored.png"
        },

        "earlybird-external": {
            "skip": true,
            "streamurl": {
              "lq": "http://dmhub.streamabc.net/dmhub-dmhstream1-aacplus-64-9169515",
              "hq": "http://localhost:9000/radiohh-earlybird-mp3-128"
            },
            "name": "Skip-Test External",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/890rtl/channels/1_600x600_89.0RTLMostWanted_bg-colored_colored.png"
        },

        "earlybird-lokal": {
          "skip": true,
          "streamurl": {
            "lq": "http://localhost:9000/radiohh-earlybird-mp3-128?context=fHA6LTE=",
            "hq": "http://localhost:9000/radiohh-earlybird-mp3-128"
          },
          "name": "Skip-Test Lokal",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/890rtl/channels/1_600x600_89.0RTLMostWanted_bg-colored_colored.png"
      }
    },

    "rhh": {
        "rhh-earlybird": {
            "streamurl": "http://skip-1hz.streamabc.net/radiohh-earlybird-mp3-128",
            "name": "Für Frühaufsteher",
            "image": "http://player.streamabc.xyz/radiohh/channels/fruehaussteher.jpg"
        },

        "rhh-goodvibes": {
            "streamurl": "http://skip-1hz.streamabc.net/radiohh-goodvibes-mp3-128",
            "name": "Good Vibes",
            "image": "http://player.streamabc.xyz/radiohh/channels/goodvibes.jpg"
        },

        "rhh-blacktears": {
            "streamurl": "http://skip-1hz.streamabc.net/radiohh-blacktears-mp3-128",
            "name": "Black Tears",
            "image": "http://player.streamabc.xyz/radiohh/channels/blacktears.jpg"
        },

        "rhh-moll4ever": {
            "streamurl": "http://skip-1hz.streamabc.net/radiohh-moll4ever-mp3-128",
            "name": "Immer dieses Moll",
            "image": "http://player.streamabc.xyz/radiohh/channels/immerdiesesmoll.jpg"
        },

        "rhh-distortedfriendl": {
            "streamurl": "http://skip-1hz.streamabc.net/radiohh-distortedfriendly-mp3-128",
            "name": "Verzerrt aber freundlich",
            "image": "http://player.streamabc.xyz/radiohh/channels/verzerrt.jpg"
        },

        "rhh-musikaushh": {
            "streamurl": "http://skip-1hz.streamabc.net/radiohh-musikaushh-mp3-128",
            "name": "Musik aus Hamburg",
            "image": "http://player.streamabc.xyz/radiohh/channels/musikausHH.jpg"
        },

        "rhh-runterfahrer": {
            "streamurl": "http://skip-1hz.streamabc.net/rhh-runterfahrer-mp3-128-34",
            "name": "Für Runterfahrer",
            "image": "http://player.streamabc.xyz/radiohh/channels/chillout.jpg"
        },

        "rhh-herzkonzert": {
            "streamurl": "http://skip-1hz.streamabc.net/rhh-herzkonzert-mp3-128-36",
            "name": "Herzkonzert",
            "image": "http://player.streamabc.xyz/radiohh/channels/Herzkonzert.jpg"
        }
    },

    "fhhalle": {
        "890rtl-mostwanted": {
            "streamurl": { "lq": "http://hz1.streamabc.net/890rtl-mostwanted-mp3-128-41" },
            "name": "89.0 RTL Most Wanted",
            "image": "http://player.streamabc.xyz/890rtl/channels/600x600_89.0RTL_bg-transparent_colored.png"
        },

        "fhhal_890rtllov_qcgd": {
            "streamurl": "http://skip-1hz.streamabc.net/fhhal_890rtllov_qcgd-mp3-256-5077301",
            "name": "89.0 RTL #Love (256kb/s)",
            "image": "http://player.streamabc.xyz/890rtl/channels/600x600_89.0RTL_bg-transparent_colored.png"
        },

        "fhhal_890rtltre_3wru": {
            "streamurl": "http://skip-1hz.streamabc.net/fhhal_890rtltre_3wru-mp3-256-3686620",
            "name": "89.0 RTL TrendingNow (256kb/s)",
            "image": "http://player.streamabc.xyz/890rtl/channels/600x600_89.0RTL_bg-transparent_colored.png"
        },

        "fhhal_rbrockenl_1rdw": {
            "streamurl": "http://skip-1hz.streamabc.net/fhhal_rbrockenl_1rdw-mp3-128-1751477",
            "name": "Radio Brocken Lovesongs",
            "image": "http://player.streamabc.xyz/radiobrocken/channels/600x600_RadioBrocken_bg-transparent_colored.png"
        },

        "fhhal_rbrockenb_ut1n": {
            "streamurl": "http://skip-1hz.streamabc.net/fhhal_rbrockenb_ut1n-mp3-128-6767438",
            "name": "Radio Brocken Best of...",
            "image": "http://player.streamabc.xyz/radiobrocken/channels/600x600_RadioBrocken_bg-transparent_colored.png"
        }
    },

    "sunshinelive": {

        "sunsl_la5iyad8f_i8xa": {
          "skip": true,
          "streamurl": {
              "lq": "https://skip-2ovh.streamabc.net/sunsl-gamescom-mp3-128-3113216",
              "hq": "https://skip-2ovh.streamabc.net/sunsl-gamescom-mp3-192-5112785"
          },
          "name": "Gamescom FM",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
          "bgcolor": "#E0EEF5",
          "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
        },

        "sunsl_dfw8j6rqy_qnlw": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-2ovh.streamabc.net/sunsl-sunsldfw8j6rqyqnlw-mp3-128-5236886",
                "hq": "https://skip-2ovh.streamabc.net/sunsl-sunsldfw8j6rqyqnlw-mp3-128-5236886"
            },
            "name": "sunshine live Afterhour",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
            "bgcolor": "#E0EEF5",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
        },

        "	sunsl_sytcqvrjq_rizn": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-2ovh.streamabc.net/sunsl-chillout-mp3-128-7525264",
                "hq": "https://skip-2ovh.streamabc.net/sunsl-chillout-mp3-128-7525264"
            },
            "name": "sunshine live Chillout",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
            "bgcolor": "#E0EEF5",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
        },

        "sunsl_xnzdiiabu_lw8b": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-2ovh.streamabc.net/sunsl-amsterdam-mp3-128-9831884",
                "hq": "https://skip-2ovh.streamabc.net/sunsl-amsterdam-mp3-128-9831884"
            },
            "name": "sunshine live Amsterdam Dance Event",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
            "bgcolor": "#E0EEF5",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
        },

        "sunsl_ufzqlb19w_cjdx": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-2ovh.streamabc.net/sunsl-playlist2-mp3-128-2672499",
                "hq": "https://skip-2ovh.streamabc.net/sunsl-playlist2-mp3-128-2672499"
            },
            "name": "sunshine live Summer Beats",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
            "bgcolor": "#E0EEF5",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
        },

        "sunsl_y4ugfsfhy_vp2d": {
          "skip": true,
          "streamurl": {
              "lq": "https://skip-2ovh.streamabc.net/sunsl-90santhems-mp3-128-6629159",
              "hq": "https://skip-2ovh.streamabc.net/sunsl-90santhems-mp3-128-6629159"
          },
          "name": "sunshine live 90s Anthems",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
          "bgcolor": "#E0EEF5",
          "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
      },

    },

    "sabc": {
        "sabc-live": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-1hz.streamabc.net/sABCTest-sabcfm-mp3-256-5131639",
                "hq": "https://skip-1hz.streamabc.net/sABCTest-sabcfm-mp3-256-5131639"
            },
            "name": "streamABC LIVE",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
        },
        "890rtl-mostwanted": {
            "skip": true,
            "streamurl": {
              "lq": "https://skip-1hz.streamabc.net/890rtl-mostwanted-mp3-128-41",
              "hq": "https://skip-1hz.streamabc.net/890rtl-mostwanted-mp3-128-41"
            },
            "name": "89.0 RTL Most Wanted",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/890rtl/channels/600x600_89.0RTL_bg-transparent_colored.png"
        }
    },

    "regiocast": {
      "rc_54dbgaa6dj2v_qzlk": {
          "skip": true,
          "streamurl": {
              "lq": "https://skip-1hz.streamabc.net/rc-bestchannelever-mp3-192-4697292",
              "hq": "https://skip-1hz.streamabc.net/rc-bestchannelever-mp3-192-4697292"
          },
          "name": "The Best Channel",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      },
      "rc_p3m27deon9ms_5kng": {
        "skip": true,
        "streamurl": {
            "lq": "https://skip-1hz.streamabc.net/rc-90s90sexperience-mp3-192-9437836",
            "hq": "https://skip-1hz.streamabc.net/rc-90s90sexperience-mp3-192-9437836"
        },
        "name": "90s90s Experience",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
    }
  },

    "hra": {
        "hra-test": {
            "skip": true,
            "streamurl": {
              "lq": "http://localhost:9000/ands-sabcantndstest-mp3-128-2548714",
              "hq": "http://skip-1hz.streamabc.net/ands-sabcantndstest-mp3-192-8046955"
            },
            "name": "Antenne Niedersachsen TEAM-STREAM",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/hra/logo_antenne_niedersachsen.png",
            "bgcolor": "#E0EEF5",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/hra/logo_antenne_niedersachsen.png"
        }

    },

    "antenne": {
        "antenne-test": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-2ovh.streamabc.net/ands-sabcantndstest-mp3-128-2548714",
                "hq": "https://skip-2ovh.streamabc.net/ands-sabcantndstest-mp3-192-8046955"
            },
            "name": "Antenne Niedersachsen TEAM-STREAM",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/hra/logo_antenne_niedersachsen.png",
            "bgcolor": "#E0EEF5",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/hra/logo_antenne_niedersachsen.png"
        }

    },

    "dmhub": {
        "dmhub1": {
            "skip": true,
            "streamurl": {
                "lq": "https://skip-2ovh.streamabc.net/dmhub-dmhstream1-mp3-128-7391782",
                "hq": "https://skip-2ovh.streamabc.net/dmhub-dmhstream1-mp3-192-3680789"
            },
            "name": "DMHUB Stream 1",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/dmhub/dmh-logo.png",
            "bgcolor": "#FFFFFF",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/dmhub/dmh-logo.png"
        }

    },

    "simulcast": {
      "swap1": {
          "skip": true,
          "streamurl": {
              "lq": "https://skip-2ovh.streamabc.net/antth_atlive_sfS8-mp3-128",
              "hq": "https://skip-2ovh.streamabc.net/antth_atlive_sfS8-mp3-128"
          },
          "name": "Simulcast Skip",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
          "bgcolor": "#FFFFFF",
          "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      },
      "swap2": {
        "skip": true,
        "streamurl": {
            "lq": "https://skip-2ovh.streamabc.net/890rtl-mostwanted-mp3-128-41",
            "hq": "https://skip-2ovh.streamabc.net/890rtl-mostwanted-mp3-128-41"
        },
        "name": "Most Wanted Swap",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      },
      "swap3": {
        "skip": true,
        "streamurl": {
            "lq": "https://skip-2ovh.streamabc.net/sunsl-gamescom-mp3-128-3113216",
            "hq": "https://skip-2ovh.streamabc.net/sunsl-gamescom-mp3-128-3113216"
        },
        "name": "Gamescom FM Swap",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      }

    },

    "weltbild": {
      "weltb_nqh1rh3iy_fncc": {
          "skip": true,
          "streamurl": {
              "lq": "https://skip-1hz.streamabc.net/weltb-gipfelstrmerundberflieger-mp3-128-5018596",
              "hq": "https://skip-1HZ.streamabc.net/weltb-gipfelstrmerundberflieger-mp3-192-8419857"
          },
          "name": "Gipfelstürmer und Überflieger",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png",
          "bgcolor": "#FFFFFF",
          "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png"
      },
      "weltb_bg273qkxk_kf6k": {
        "skip": true,
        "streamurl": {
            "lq": "https://skip-1hz.streamabc.net/weltb-mdl-mp3-128-5358588",
            "hq": "https://skip-1HZ.streamabc.net/weltb-mdl-mp3-192-2757897"
        },
        "name": "Meine deutschen Lieblingshits",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png"
      },
      "weltb_v7kuxeata_wvhj": {
        "skip": true,
        "streamurl": {
            "lq": "https://skip-1hz.streamabc.net/weltb-wbrpopd-mp3-128-2321071",
            "hq": "https://skip-1HZ.streamabc.net/weltb-wbrpopd-mp3-192-9138824"
        },
        "name": "Weltbild Radio Pop Deutsch",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png"
      },
      "weltb_c5nxyjxmy_udr3": {
        "skip": true,
        "streamurl": {
            "lq": "https://skip-1hz.streamabc.net/weltb-weltbc5nxyjxmyudr3-mp3-128-4520430",
            "hq": "https://skip-1HZ.streamabc.net/weltb-weltbc5nxyjxmyudr3-mp3-192-5145138"
        },
        "name": "Weltbild Radio Volksmusik",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/weltbild/logo-wb.png"
      }
    },

    "klassikradio": {

      "klassikr-movie": {
        "skip": true,
        "streamurl": {
            "lq": "https://stream.klassikradio.de/movie/mp3-128/sabcplayer/",
            "hq": "https://stream.klassikradio.de/movie/mp3-192/sabcplayer/"
        },
        "name": "Klassik Radio Movie",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg"
      },

      "klassikr-klassikdrea": {
        "skip": true,
        "streamurl": {
            "lq": "https://stream.klassikradio.de/dreams/mp3-128/sabcplayer/",
            "hq": "https://stream.klassikradio.de/dreams/mp3-192/sabcplayer/"
        },
        "name": "Klassik Radio Klassik Dreams",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg"
      },

      "klassikr-puremozart": {
        "skip": true,
        "streamurl": {
            "lq": "https://stream.klassikradio.de/mozart/mp3-128/sabcplayer/",
            "hq": "https://stream.klassikradio.de/mozart/mp3-192/sabcplayer/"
        },
        "name": "Klassik Radio Pure Mozart",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg"
      },

      "klassikr-opera": {
        "skip": true,
        "streamurl": {
            "lq": "https://stream.klassikradio.de/opera/mp3-128/sabcplayer/",
            "hq": "https://stream.klassikradio.de/opera/mp3-192/sabcplayer/"
        },
        "name": "Klassik Radio Opera",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg"
      },

      "klassikr-loungebeat": {
        "skip": true,
        "streamurl": {
            "lq": "https://stream.klassikradio.de/lounge-beat/mp3-128/sabcplayer/",
            "hq": "https://stream.klassikradio.de/lounge-beat/mp3-192/sabcplayer/"
        },
        "name": "Klassik Radio Lounge Beat",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/klassikradio/600x600_logo_klassikradio.jpg"
      }

    },

    "radio21": {

      "radio21_cwry69h_y69y": {
        "skip": true,
        "streamurl": {
            "lq": "https://bestofrockfm.stream.vip/softrock/mp3-128/sabcplayer/",
            "hq": "https://bestofrockfm.stream.vip/softrock/mp3-192/sabcplayer/"
        },
        "name": "Best of Rock FM - Softrock",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      },

      "radio21_opmnrau_hji5": {
        "skip": true,
        "streamurl": {
            "lq": "https://bestofrockfm.stream.vip/altrock/mp3-128/sabcplayer/",
            "hq": "https://bestofrockfm.stream.vip/altrock/mp3-192/sabcplayer/"
        },
        "name": "Best of Rock FM - Alternative Rock",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      },

      "radio21_atam41o_agkt": {
        "skip": true,
        "streamurl": {
            "lq": "https://bestofrockfm.stream.vip/giganten/mp3-128/sabcplayer/",
            "hq": "https://bestofrockfm.stream.vip/giganten/mp3-192/sabcplayer/"
        },
        "name": "Best of Rock FM - Giganten des Rock",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      },

      "radio21_xmykdbf_hd6u": {
        "skip": true,
        "streamurl": {
            "lq": "https://bestofrockfm.stream.vip/neu/mp3-128/sabcplayer/",
            "hq": "https://bestofrockfm.stream.vip/neu/mp3-192/sabcplayer/"
        },
        "name": "Best of Rock FM - Neu & Angesagt",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      }
    },

    "westfunk": {
      "wefu_zvyxukrgw5_2eve": {
        "skip": true,
        "streamurl": {
            "lq": "http://westfunk.stream.vip/rb-in-the-mix/mp3-128/sabcplayer/",
            "hq": "http://westfunk.stream.vip/rb-in-the-mix/mp3-256/sabcplayer/"
        },
        "name": "Radio Bochum - In the Mix",
        "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
        "bgcolor": "#FFFFFF",
        "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
      }
    },

    "m6": {
        "m6_ciedw3r5rxsk_vbjn": {
          "skip": false,
          "streamurl": {
              "lq": "https://m6.stream.vip/rtl2/mp3-128/sabcplayer/",
              "hq": "https://m6.stream.vip/rtl2/mp3-192/sabcplayer/"
          },
          "name": "RTL 2",
          "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/m6/c300.png",
          "bgcolor": "#FFFFFF",
          "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/m6/c300.png"
        }
      },

  "slpride": {
    "sunsl_nhln6mjey_l0z1": {
      "skip": true,
      "streamurl": {
        "lq": "https://skip-2ovh.streamabc.net/sunsl-sslpride-mp3-128-6529092",
        "hq": "https://skip-2ovh.streamabc.net/sunsl-sslpride-mp3-192-1744824"
      },
      "name": "sunshine live and pride",
      "image": "https://sunshine-live.imgix.net/files/streams/stream-tile-ssl-pride.jpg?auto=format&w=300&h=300&dpr=2",
      "bgcolor": "#FFFFFF",
      "header": "https://sunshine-live.imgix.net/files/streams/stream-tile-ssl-pride.jpg?auto=format&w=300&h=300&dpr=2"
    }
  },

  "gamescomfm": {
    "sunsl_la5iyad8f_i8xa": {
      "skip": true,
      "streamurl": {
        "lq": "https://skip-2ovh.streamabc.net/sunsl-gamescom-mp3-128-3113216",
        "hq": "https://skip-2ovh.streamabc.net/sunsl-gamescom-mp3-192-5112785"
      },
      "name": "Gamescom FM",
      "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/channels/600x600__sunshine_live_colored.png",
      "bgcolor": "#E0EEF5",
      "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sunshinelive/logo.svg"
    }

  },

  "radioandernach": {
    "ande_itxhbn6plo_cbv1": {
      "skip": true,
      "streamurl": {
        "lq": "https://skip-2ovh.streamabc.net/ande-andeitxhbn6plocbv1-mp3-192-5720965",
        "hq": "https://skip-2ovh.streamabc.net/ande-andeitxhbn6plocbv1-mp3-192-5720965"
      },
      "name": "Radio Andernach",
      "image": "https://streamabc-player.s3.eu-central-1.amazonaws.com/bwtv/andernach.png",
      "bgcolor": "#E0EEF5",
      "header": "https://streamabc-player.s3.eu-central-1.amazonaws.com/bwtv/andernach.png"
    }

  },

  "radiofantasy": {
    "rfa_4usy8ejp4eh_zjic": {
      "skip": true,
      "streamurl": {
        "lq": "https://skip-2ovh.streamabc.net/rfa-rfa4usy8ejp4ehzjic-mp3-128-3006384",
        "hq": "https://skip-2ovh.streamabc.net/rfa-rfa4usy8ejp4ehzjic-mp3-192-7572835"
      },
      "name": "Radio Fantasy",
      "image": "https://streamabc-player.s3.eu-central-1.amazonaws.com/radiofantasy/logo.png",
      "bgcolor": "#dc1e09",
      "header": "https://streamabc-player.s3.eu-central-1.amazonaws.com/radiofantasy/logo.png"
    }

  },

      "bild": {
          "qc_m0757nmisxae_wda9": {
            "skip": true,
            "streamurl": {
                "lq": "https://quantumcast.stream.vip/bild1/mp3-192/",
                "hq": "https://quantumcast.stream.vip/bild1/mp3-192/"
            },
            "name": "Channel 1",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png",
            "bgcolor": "#FFFFFF",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png"
          },

          "qc_9rsdmhrvdlsy_cs5o": {
            "skip": true,
            "streamurl": {
                "lq": "https://quantumcast.stream.vip/bild2/mp3-192/",
                "hq": "https://quantumcast.stream.vip/bild2/mp3-192/"
            },
            "name": "Channel 2",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png",
            "bgcolor": "#FFFFFF",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png"
          }
        },

        "quantumcast": {
          "qc_ah8kvbzvrijr_awaj": {
            "skip": true,
            "streamurl": {
                "lq": "https://quantumcast.stream.vip/louis/mp3-192/",
                "hq": "https://quantumcast.stream.vip/louis/mp3-192/"
            },
            "name": "Louis",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png",
            "bgcolor": "#FFFFFF",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png"
          },

          "qc_0dm7w3mdgo3b_koaz": {
            "skip": true,
            "streamurl": {
                "lq": "https://quantumcast.stream.vip/Marko-Test/mp3-192/",
                "hq": "https://quantumcast.stream.vip/Marko-Test/mp3-192/"
            },
            "name": "Diorama und Diary of Dreams",
            "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png",
            "bgcolor": "#FFFFFF",
            "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png"
          }
        },

  "rc-digital": {
    "dds_v3kfb6a2sgj_wwgh": {
      "skip": true,
      "streamurl": {
        "lq": "https://dds.streamabc.net/dds-dds90s90ssound-mp3-320-7896868",
        "hq": "https://dds.streamabc.net/dds-dds90s90ssound-mp3-320-7896868"
      },
      "name": "90s90s",
      "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png",
      "bgcolor": "#FFFFFF",
      "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/logo.png"
    },

    "dds_dwn9wwdbqfu_ikpd": {
      "skip": true,
      "streamurl": {
        "lq": "https://dds.streamabc.net/dds-80s80sdm-mp3-320-4399521",
        "hq": "https://dds.streamabc.net/dds-80s80sdm-mp3-320-4399521"
      },
      "name": "80s80s DM",
      "image": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png",
      "bgcolor": "#FFFFFF",
      "header": "https://s3.eu-central-1.amazonaws.com/streamabc-player/sabc/channels/2000px-Logo_BILD.svg.png"
    }
  }


}



// WEBPACK FOOTER //
// ./src/js/config.js